"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosClient = void 0;
const tslib_1 = require("tslib");
const common_types_1 = require("@as-react/common-types");
const axios_1 = tslib_1.__importDefault(require("axios"));
const axios_auth_refresh_1 = tslib_1.__importDefault(require("axios-auth-refresh"));
const EventUtil_1 = require("./EventUtil");
const axiosClient = axios_1.default.create({});
exports.axiosClient = axiosClient;
axiosClient.interceptors.response.use((response) => response, (error) => {
    var _a;
    switch ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) {
        case common_types_1.HTTPStatusCode.Forbidden:
            EventUtil_1.EventUtil.dispatch(common_types_1.EventEnum.USER_SECURITY_LEVEL_TOO_LOW);
            break;
        default:
            return Promise.reject(error);
    }
});
if (typeof window !== 'undefined' && ((_b = (_a = window === null || window === void 0 ? void 0 : window.SITE) === null || _a === void 0 ? void 0 : _a.Config) === null || _b === void 0 ? void 0 : _b.feature_toggles.use_new_auth_flow)) {
    axiosClient.interceptors.request.use((config) => {
        if (config.withCredentials) {
            const token = sessionStorage.getItem(common_types_1.AUTH_SESSION_STORAGE_KEY);
            if (token) {
                const { access_token } = JSON.parse(token);
                config.headers['Authorization'] = `Bearer ${access_token}`;
            }
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });
    (0, axios_auth_refresh_1.default)(axiosClient, failedRequest => {
        const token = sessionStorage.getItem(common_types_1.AUTH_SESSION_STORAGE_KEY);
        if (!token) {
            return Promise.resolve();
        }
        const { refresh_token } = JSON.parse(token);
        const formdata = new FormData();
        formdata.append('refresh_token', refresh_token);
        formdata.append('grant_type', 'refresh_token');
        formdata.append('client_id', window.SITE.Config.oauth.clientId);
        return axiosClient
            .request({
            url: '/authorization-server/oauth2/token',
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: formdata,
        })
            .then(tokenRefreshResponse => {
            sessionStorage.setItem(common_types_1.AUTH_SESSION_STORAGE_KEY, JSON.stringify(tokenRefreshResponse.data));
            failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token;
            return Promise.resolve();
        });
    });
}
//# sourceMappingURL=axios.util.js.map